import { languageTag } from '@/lib/locale';

/** A content date as people write it: "6 October 2026". */
export function formatDate(date: string) {
  return new Intl.DateTimeFormat(languageTag(), {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    // Content dates are calendar days written as midnight UTC; any other zone can show the day before.
    timeZone: 'UTC',
  }).format(new Date(date));
}
